export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]/i;

export const phoneRegex = /^[ ()]*([0-9][ ()]*){8}$/;

export const noNumberRegex = /\d/;

export const noLetterRegex = /[a-zA-Z æøåÆØÅ]/;

export const firstNameLastNameRegex = /^(\S*[a-zA-Z æøåÆØÅ]\S*\s){1,}\S*[a-zA-Z æøåÆØÅ]\S*$/;

export const passwordRegex = /^(?=.*\d)(?=.*[a-zæøå])(?=.*[A-ZÆØÅ])(?=.*[a-zæøåA-ZÆØA]).{8,64}$/gm;
export const passwordRegexStrict =
    /^(?=.*[a-zæøå])(?=.*[A-ZÆØÅ])(?=.*\d)(?=.*[@#$%^&*\-_+=\[\]{}|\\:',.?/`~"();!])[0-9A-ZÆØÅa-zæøå@#$%^&*\-_+=\[\]{}|\\:',.?/`~"();! ]{8,64}/;
